module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.blogLoaded) ? _c('c-loader') : _c('div', [_c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.itemList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "c-paginate"
  }, [(_vm.currentPage !== 1) ? _c('router-link', {
    staticClass: "c-paginate__button",
    attrs: {
      "to": {
        query: {
          page: _vm.lastPage
        }
      }
    }
  }, [_vm._v("←")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-paginate-current"
  }, [_vm._v(_vm._s(_vm.currentPage) + " / " + _vm._s(_vm.totalPages) + " ")]), _vm._v(" "), (_vm.currentPage !== _vm.totalPages) ? _c('router-link', {
    staticClass: "c-paginate__button",
    attrs: {
      "to": {
        query: {
          page: _vm.nextPage
        }
      }
    }
  }, [_vm._v("→")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e9e9b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginate.vue
// module id = 273
// module chunks = 0